import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import PubSub from 'pubsub-js';
import { action, computed, observable, reaction } from 'mobx';
import {
    Control,
    ReactNodeGenerator,
    validators,
    Disposers
} from 'lib/helpers';
import { observer } from 'mobx-react';
import { environment } from 'lib/environment';
import { httpClient } from 'domain/utils/httpClient';
import { TextField, InputAdornment } from '@mui/material';
import { EssayCreateViewModel } from 'scenes/essay/EssayModels';
import Swal from 'sweetalert2';


type Props = {
    onSaveSuccess: () => void,
}

type State = {
    isOpen: boolean;
    classroomId: number;
    topic: string | null;
    timeLimit: string | null;
    instructions: string | null;
}

export interface TeacherCreateEssayModal_Data {
    classroomId: number;
}

@observer
export class TeacherCreateEssayModal extends React.Component<Props, State> {

    state: State = {
        isOpen: false,
        classroomId: 0,
        topic: null,
        timeLimit: null,
        instructions: null
    };

    private pubSubToken: string | null = null;
    private readonly disposers = new Disposers();

    onCloseClick() {
        this.closeModal();
    }

    onModalOpened() {

    }

    private closeModal = () => {
        this.setState({ isOpen: false, topic: null, timeLimit: null });
    }

    onSaveClick = async () => {
        if (this.state.topic == null) {
            Swal.fire({ 'icon': 'info', text: 'Topic required' });
            return;
        }
        const url = `${environment.apiServer}/essay/create`;
        var data = new EssayCreateViewModel(this.state.classroomId, this.state.topic, this.state.timeLimit, this.state.instructions);
        await httpClient.axios.postWithSweetAlert(url, data);
        this.props.onSaveSuccess();
        await Swal.fire({ 'icon': 'success', text: 'Essay create OK' });
        this.closeModal();
    }

    *renderer(): ReactNodeGenerator {
        const self = this;
        yield (
            <Modal isOpen={this.state.isOpen}
                size="lg"
                key="modal"
                centered
                onOpened={() => this.onModalOpened}>
                <ModalHeader>
                    <div>Create Essay</div>
                </ModalHeader>
                <ModalBody>
                    <div>
                        <TextField
                            id="outlined-basic"
                            sx={{ m: 1, width: '70ch' }}
                            label="Essay Topic"
                            variant="outlined"
                            required
                            onChange={this.onTopicChange}
                        />
                    </div>
                    <div style={{ height: '20px' }}></div>
                    <div>
                        <TextField
                            label="Time Limit"
                            id="outlined-start-adornment"
                            sx={{ m: 1, width: '70ch' }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">Example: 1h 30m</InputAdornment>,
                            }}
                            onChange={this.onTimeLimitChange}
                        />
                    </div>
                    <div style={{ height: '20px' }}></div>
                    <div>
                        <TextField
                            label="Comment"
                            id="outlined-start-adornment"
                            sx={{ m: 1, width: '70ch' }}
                            multiline={true}
                            rows={4}
                            onChange={this.onInstructionsChange}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-primary"
                        onClick={this.onSaveClick} value="test">Create Essay
                    </button>
                    <button type="button" className="btn btn-secondary"
                        onClick={() => self.onCloseClick()} value="test">Cancel
                    </button>
                </ModalFooter>
            </Modal>
        );
    }

    render() {
        return Array.from(this.renderer());
    }

    componentDidMount() {
        this.pubSubToken = PubSub.subscribe("TeacherCreateEssayModal_Open", this.mySubscriber);
    }

    componentWillUnmount() {
        if (this.pubSubToken) {
            PubSub.unsubscribe(this.pubSubToken);
        }
        this.disposers.dispose();
    }

    mySubscriber = (msg: any, data: TeacherCreateEssayModal_Data) => {
        const self = this;
        self.setState({ isOpen: true, classroomId: data.classroomId });
    }

    onTopicChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ topic: event.target.value });
    }

    onTimeLimitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ timeLimit: event.target.value });
    }

    onInstructionsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ instructions: event.target.value });
    }
}